export default "__VITE_ASSET__CCgvvjS2__"